import { useDelegatedFetchGeneratedContent } from 'content-assistance-lib/hooks/useFetchContentAssistanceContent';
import UsageTracker, { useTracker } from 'ContentEditorUI/utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentAssistanceRequestDelegate = () => {
  useDelegatedFetchGeneratedContent('contentEditor-inpage', UsageTracker.getTracker());
  return null;
};
const ContentAssistanceRequestDelegateWithTracker = () => {
  const tracker = useTracker();
  return tracker && /*#__PURE__*/_jsx(ContentAssistanceRequestDelegate, {});
};
export default ContentAssistanceRequestDelegateWithTracker;